var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.4284 9.41398L1.71225 0.697874L0.762155 1.64797L8.56063 9.44639L0.785829 17.2212L1.73593 18.1713L10.452 9.45518L10.4196 9.42277L10.4284 9.41398Z"}));
}

ChevronRight.defaultProps = {"viewBox":"0 0 11 19"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
